module.exports = __webpack_public_path__ + "static/media/about.8402569e531dfef20e15c8802face9c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about.png
// module id = 2656
// module chunks = 1